<template>

  <body>
    <header data-copilot="true" class="section overflow_hidden overflow_clip padding_small">
      <div class="min-height_100dvh">

        <div class="container z-index_2 position_relative text-align_center"><img
            src="https://cdn.prod.website-files.com/686b0fce62ce6721b0225627/6875166c9fa43fc5647169d7_logo%20256%20dark%20bg.png"
            loading="lazy" alt=""></div>
        <div class="container">
          <div class="w-layout-grid grid_2-col height_100percent bordered margin-top_small">
            <div
              style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
              class="card_body padding_small">
              <h3 class="heading_h4 w-node-f8ee0a7a-f949-e000-ca4c-1d6780cd2338-b1bec576">Leap Perks Program</h3>
              <p class="paragraph_small margin-bottom_none">Designed exclusively for <strong>subscribed Leap
                  clients</strong>, the <strong>Leap Perks Program</strong> brings additional value and flexibility to
                your city-wide advertising subscription.</p>
            </div>
            <div
              style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
              class="form w-form">
              <form class="flex_vertical gap-xsmall" aria-label="Email Form">
                <h5 class="heading_h2">Client Login</h5>
                <input class="input_field w-input" maxlength="256" name="email" data-name="email" placeholder="Email"
                  type="text" id="email" required="" v-model="email">
                <input class="input_field w-input" maxlength="256" name="pswrd" data-name="pswrd" placeholder="Password"
                  type="password" id="pswrd" required="" v-model="password">
                <div class="button radius_medium" @click="login">Login</div>
                <p class="paragraph_medium margin-bottom_none text-align_center">or</p>
                <div class="button radius_medium is-secondary" @click="$router.push('/register')">Register</div>

              </form>

            </div>
            <ul role="list" id="w-node-a3ee1c64-ae0f-9aac-c410-428e3cb6fc23-b1bec576"
              style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
              class="grid_3-col gap-small position_relative padding_small w-list-unstyled">
              <li class="margin-bottom_none">
                <div class="is-large-1x1 margin-bottom_xsmall is-background"><svg xmlns="http://www.w3.org/2000/svg"
                    width="100%" height="100%" viewBox="0 0 24 24" fill="none">
                    <path d="M5.25 6.75H18.75V17.25H5.25V6.75Z" stroke="currentColor" stroke-width="1.5"
                      stroke-linejoin="round"></path>
                    <path d="M5.25 6.75L12 12L18.75 6.75" stroke="currentColor" stroke-width="1.5"
                      stroke-linejoin="round"></path>
                  </svg></div>
                <h5 class="heading_h5">Send an email</h5>
                <p class="text-color_secondary">Share your ideas or ask us anything.</p>
                <div><a href="#" class="text-link is-secondary">hello@leapdigitalmedia.ca</a></div>
              </li>
              <li class="margin-bottom_none">
                <div class="is-large-1x1 margin-bottom_xsmall is-background"><svg xmlns="http://www.w3.org/2000/svg"
                    width="100%" height="100%" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12.5 18.25C16.2279 18.25 19.25 15.2279 19.25 11.5C19.25 7.77208 16.2279 4.75 12.5 4.75C8.77208 4.75 5.75 7.77208 5.75 11.5C5.75 12.6007 6.01345 13.6398 6.48072 14.5578L5 19L9.71819 17.6519C10.5664 18.0361 11.5082 18.25 12.5 18.25Z"
                      stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path>
                  </svg></div>
                <h4 class="heading_h5">Give us a call</h4>
                <p class="text-color_secondary">We’re here Mon–Fri, 8am–5pm PT.</p>
                <div>+1 (705) 220-2273<br></div>
              </li>
              <li class="margin-bottom_none">
                <div class="is-large-1x1 margin-bottom_xsmall is-background"><svg xmlns="http://www.w3.org/2000/svg"
                    width="100%" height="100%" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M16.3918 14.8527C20.2489 10.9956 17.2769 4.25 12 4.25C6.72299 4.25 3.75102 10.9956 7.60817 14.8527L12 19.25L16.3918 14.8527Z"
                      stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path>
                    <circle cx="12" cy="10.25" r="2" stroke="currentColor" stroke-width="1.5"></circle>
                  </svg></div>
                <h4 class="heading_h5">Stop by our office</h4>
                <p class="text-color_secondary">Visit us and meet our creative team.</p>
                <div>435 Notre Dame Ave,<br>Sudbury, ON, P3C 5K6<br>Canada</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>

  </body>
</template>

<script>
import { auth } from '@/firebase';
import { signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  name: 'HomeView',
  data() {
    return {
      email: '',
      password: '',
    }
  },
  async mounted() {
    // Check if user is already logged in
    onAuthStateChanged(auth, (user) => {
      if (user) {
        this.$router.push('/portal'); // Redirect to portal if user is already signed in
      } else {
        // User is signed out
        console.log("No user is signed in.");
      }
    });

  },
  components: {
  },
  computed: {
    ...mapState({
      user: state => state.user,
      isAuthenticated: state => state.isAuthenticated,
      userData: state => state.userData,
    }),
  },
  methods: {
    ...mapMutations(['setUser', 'clearUser']),
    ...mapActions(['fetchUserData']),
    async login() {
      // Implement login logic here
      console.log('Logging in with', this.email, this.password);
      try {
        const userCredential = await signInWithEmailAndPassword(auth, this.email, this.password);
        // Signed in
        const user = userCredential.user;
        console.log('User logged in:', user);
        this.setUser(user);
        // get user data
        await this.fetchUserData(user.uid);
        console.log('User data fetched:', this.userData);
        this.$router.push('/portal'); // Redirect to portal after login
      } catch (error) {
        console.error('Login error:', error);
        alert('Login failed: ' + error.message);
      }
      // You can use Firebase Auth or any other authentication method here
      this.$router.push('/portal'); // Redirect to portal after login   
    }
  }
}
</script>
